module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "level1-titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-toc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Dedications")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front04"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front05"
    }
  }, [_vm._v("Foreword by Tony La Russa")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front06"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c001"
    }
  }, [_vm._v("GAME ONE")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Fear Factor")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locked In")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I’m Gonna Kill You!”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Peeker")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pitcher’s Tale")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praying for Change")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GAME TWO")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gonzalez Must Pay")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Light My Fire")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whodunit")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being There")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under Pressure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GAME THREE")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.K.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thing of Beauty")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kiss My Ass")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Nights in August")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note on Sources")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-footnotes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/footnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footnotes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0